<template>
  <div>
    <el-table
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      border
      stripe
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        label="类型对应的值"
        align="center"
        prop="value"
      ></el-table-column>
      <el-table-column
        label="类型描述"
        align="center"
        prop="describe"
      ></el-table-column>
      <el-table-column label="内容" align="center" prop="rule1">
      </el-table-column>
      <el-table-column label="操作" align="center" prop="icon" fixed="right">
        <template slot-scope="scope">
          <el-button
            type="primary"
            plain
            @click="UpdateConfigTypeButton(scope.row)"
            >编辑</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="[10, 20, 50, 100]"
      :current-page="current"
      :page-size="size"
      :total="total"
    >
    </el-pagination>
    <el-dialog
      :title="parment"
      :visible.sync="dialogVisible"
      width="800px"
      append-to-body
      :before-close="handleClose"
    >
      <el-form
        :model="editForm"
        ref="editForm"
        label-width="100px"
        class="demo-editForm"
      >
        <el-form-item label-width="100px" label="类型值">
          <el-input v-model="value"></el-input>
        </el-form-item>
        <el-form-item label-width="100px" label="内容" v-if="types == 'SHARE'">
          <el-input v-model="rule1"></el-input>
        </el-form-item>
        <el-form-item
          label-width="180px"
          label="分享广告(尺寸690*280)"
          prop="storeGoodsCover"
          v-if="types == 'HOMEPAGE_INVITATION_IMAGE'"
        >
          <VploadImg
            :limit="1"
            v-bind:file-list="filesd"
            :type="1"
            @submitImg="getImg"
          ></VploadImg>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm()">完成</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import VploadImg from "../inc/VploadImgTwo";
export default {
  name: "ConfigType",
  components: {
    VploadImg,
  },
  data() {
    return {
      searchForm: {},
      delBtlStatu: true,
      tableData: [],
      multipleSelection: [],
      filesd: [],
      editForm: {},
      total: 0,
      size: 10,
      current: 1,
      dialogVisible: false,
      value: "",
      types: "",
      parment: "",
      rule1: "",
      id: "",
    };
  },
  created() {
    this.getConfigType();
  },
  methods: {
    getImg(url, add) {
      if (add == 1) {
        this.rule1 = url;
      } else if (add == 0) {
        this.rule1 = "";
      }
      console.log(this.rule1);
    },
    handleClose() {
      this.dialogVisible = false;
    },
    submitForm() {
      this.$axios
        .post("/admin/systemConfig/updSystemConfig", {
          describe: this.parment,
          rule1: this.rule1,
          value: this.value,
          id: this.id,
        })
        .then((res) => {
          this.dialogVisible = false;
          this.getConfigType();
          this.$message({
            showClose: true,
            message: "恭喜你，操作成功",
            type: "success",
            onClose: () => {},
          });
        });
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.delBtlStatu = val.length == 0;
    },

    handleSizeChange(val) {
      this.size = val;
      this.getConfigType();
    },
    handleCurrentChange(val) {
      this.current = val;
      this.getConfigType();
    },
    //获取常量数据配置列表
    getConfigType() {
      this.searchForm.pageNo = this.current;
      this.searchForm.pageSize = this.size;
      this.$axios
        .post("/admin/systemConfig/getSystemConfigPage", this.searchForm)
        .then((res) => {
          this.tableData = res.data.records;
          this.current = res.data.pages;
          this.total = res.data.total;
          this.size = res.data.size;
        });
    },
    UpdateConfigTypeButton(id) {
      this.parment = id.describe;
      this.types = id.type;
      if (id.value != null) {
        this.value = id.value;
      } else {
        this.value = "";
      }
      if (id.rule1 != null) {
        this.rule1 = id.rule1;
        var les = {
          url: this.rule1,
        };
        this.filesd = [];
        this.filesd.push(les);
      } else {
        this.rule1 = "";
      }

      this.id = id.id;
      this.dialogVisible = true;
    },
  },
};
</script>

<style scoped>
.el-button {
  padding: 0 10px;
  height: 35px;
  line-height: 35px;
  font-size: 15px;
  margin-right: 10px;
}
</style>
